<template>
  <div class="content">
    <!-- 标题 -->
    <div class="title">
      <span class="name">{{ title }}</span>
      <span class="count" v-if="messageData.length > 0"> ({{ messageData.length }}条未读)</span>
      <span class="next" v-if="messageData.length > 1 && messageData.length - 1 > messageIndex">
        <el-link type="primary" :underline="false" title="下一条" @click="next"><i class="el-icon-right"></i></el-link>
      </span>
    </div>
    <!-- 内容区 -->
    <div class="message-data">
      <div class="message-item" v-if="messageData.length > 0">
        <div class="text-title">{{ messageData[messageIndex].title }}</div>
        <div class="text-content" v-html="messageData[messageIndex].messageContent"></div>
        <div class="text-btn" v-if="messageData[messageIndex].messageContent.length > 66">
          <el-link type="primary" :underline="false" @click="handleDetail">查看详情 <i class="el-icon-arrow-right" style="margin-left: -3px"></i></el-link>
        </div>
      </div>

      <div class="message-item" v-else>
        <el-empty description="暂无未读消息" :image-size="70"></el-empty>
      </div>
    </div>
    <!-- 页脚 -->
    <div class="message-foot">
      <span class="know" v-if="messageData.length > 0">
        <el-button style="height: 26px" size="mini" type="primary" @click="iknow">我知道了</el-button>
      </span>
      <span class="more">
        <el-button size="mini" plain type="primary" @click="toHref('/user/message')"> 查看更多 </el-button>
      </span>
    </div>

    <!-- 消息内容弹窗显示 -->
    <el-dialog width="640px" :title="messageItem.title" append-to-body :visible.sync="showDialog" :close-on-click-modal="false" @close="() => closeDialog()" @closed="closedDialog">
      <div class="message-dialog">
        <div class="time">发布于 {{ moment(messageItem.gmtCreate).format('YYYY-MM-DD HH:mm:ss') }}</div>
        <div class="message-content" v-html="messageItem.messageContent"></div>
      </div>
      <div class="footer-btn">
        <el-button style="height: 26px" size="small" type="primary" @click="() => closeDialog(true)">我知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fetchNoticeList, fetchNoticeRead, fetchUseMoney, updateNoticeConfig } from '@/api/user'
import moment from 'moment'
let timer
let timerMoney

export default {
  name: 'Message',
  props: {
    title: String,
    toUrl: Function,
    closeMessage: Function,
    checkMessage: Function
  },
  data() {
    return {
      moment,
      messageIndex: 0,
      messageData: [],

      // 查看消息弹窗
      needRefresh: false,
      showDialog: false,
      messageItem: {}
    }
  },
  computed: {
    ...mapGetters(['isLogin'])
  },
  watch: {
    isLogin: {
      handler(val) {
        if (val) {
          // 获取站内未读消息
          this.getNotice(true, true)
          this.getMoeny()
        }
      },
      deep: true,
      immediate: true
    }
  },

  mounted() {
    // 定时刷新提醒
    timer = setInterval(() => {
      this.getNotice(true)
    }, 1000 * 30)

    timerMoney = setInterval(() => {
      this.getMoeny()
    }, 1000 * 60 * 10)
  },

  unmounted() {
    clearInterval(timer)
    clearInterval(timerMoney)
  },

  methods: {
    // 获取消息
    async getNotice(isShow, addReadCount) {
      const parmas = {
        isRead: 0,
        pageNum: 1,
        pageSize: 100
      }

      const resp = await fetchNoticeList(parmas)
      if (resp.success) {
        // 如果有未读消息，更新消息提醒标记
        if (resp.data.total) {
          this.$store.commit('user/setNoticeCount', resp.data.total)
        }

        let data = []
        // 货物站内消息未读数据
        resp.data.records.map(d => {
          // 已读次数未达到设置的次数，场景1 - 有推送时间，则当前时间小于推送截止时间，场景2 -无推送时间
          if (d.showType === 3 && d.reminderCount < d.reminderConfCount && ((d.reminderEnd && moment().valueOf() < moment(d.reminderEnd).valueOf()) || !d.reminderEnd)) {
            data.push(d)
          }
        })
        // console.log('站内消息', data)
        this.messageData = data

        // 如果要强制显示
        if (data.length > 0 && isShow) {
          this.$emit('checkMessage')

          // 如果是页面打开或刷新，修改消息已读次数，超过3次不在主动显示
          if (addReadCount) {
            this.updateNotice(data[0].id)
          }
        } else {
          this.$emit('closeMessage')
        }
      }
    },

    // 获取可用余额提醒
    async getMoeny() {
      const resp = await fetchUseMoney()
      if (resp.success) {
      }
    },

    // 下一条
    next() {
      this.setReadStatus(this.messageData[this.messageIndex].id, true)
    },

    // 设置消息已读
    async setReadStatus(id, isShow) {
      const resp = await fetchNoticeRead([id], 'read')
      if (resp.success) {
        this.getNotice(isShow)
      }
    },

    // 更新提醒次数
    async updateNotice(id) {
      const resp = await updateNoticeConfig(id)
    },

    // 点击我知道了
    iknow() {
      if (this.messageData.length > 1) {
        this.next()
      } else {
        this.setReadStatus(this.messageData[this.messageIndex].id, false)
      }
    },

    // 跳转到用户中心
    toHref(href) {
      this.$emit('closeMessage')
      if (location.pathname === href) return
      this.$emit('toUrl', href)
    },

    // 主动关闭消息浮窗
    closeNotice() {
      this.$emit('closeMessage')
      this.setReadStatus(this.messageData[this.messageIndex].id, false)
    },

    // 显示消息详情
    handleDetail() {
      this.messageItem = this.messageData[this.messageIndex]
      this.showDialog = true
    },

    // 关闭弹窗
    closeDialog(bool) {
      this.showDialog = false

      // 点击弹窗关闭，标记当前消息为已读，并切换到下一条消息
      if (bool) {
        this.setReadStatus(this.messageData[this.messageIndex].id, true)
      }
    },

    // 完全关闭弹窗
    closedDialog() {}
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
